import { useMutation } from "@apollo/client";
import { Typography } from "@mui/material";
import { useAlerts } from "components/Alerts/AlertProvider";
import { Dialog } from "components/Dialog";
import { gql } from "generated-graphql/gql";
import { TierIiReportKind } from "generated-graphql/graphql";
import { REPORTS_QUERY, ReportRow } from ".";

const CLOSE_REPORT_MUTATION = gql(`
  mutation CloseReport($tierIIReportId: ID!) {
    closeReport(tierIIReportId: $tierIIReportId)
  }
`);

export const CloseReportDialog = ({
  onClose,
  report,
}: {
  onClose: () => void;
  report: ReportRow;
}) => {
  const alerts = useAlerts();

  const [closeReport, { loading: closeReportLoading }] = useMutation(
    CLOSE_REPORT_MUTATION,
    {
      variables: { tierIIReportId: report.tierIIReportId ?? "" },
      refetchQueries: [REPORTS_QUERY],
      onCompleted(data) {
        if (data.closeReport) {
          alerts.success("Report closed successfully.");
        } else {
          alerts.error("This report could not be closed.");
        }
        onClose();
      },
      onError(err) {
        alerts.error("An error occurred while closing the report.");
      },
    }
  );

  if (report.tierIIReportId) {
    return (
      <Dialog
        open
        title="Are you sure?"
        onClose={onClose}
        primaryActionButtonProps={{
          onClick: () => closeReport(),
          loading: closeReportLoading,
        }}
      >
        <Typography>
          Are you sure you want to close this report? This action cannot be
          undone. We will not delete any facility or chemical data, but we will
          delete Assignee/Reviewer information from this report.
        </Typography>
      </Dialog>
    );
  } else {
    return null;
  }
};
